import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import stl from "./CarReportSection.module.css";
import SingleInspectionItem from "./SingleInspectionItem";
import ARPointsInspectionSVG from "./images/ARPointsInspectionSVG";
import ENPointsInspectionSVG from "./images/ENPointsInspectionSVG";
import { trackEvents } from "@/common/events/events";
import { useLang } from "@/common/Contexts/LanguageContext";
import { api__getPostInspection } from "@/apis/posts/getInspection";
import useIsMobile from "@hooks/useIsMobile";
import useHelpers from "@hooks/useHelpers";
import { AuthPopupHOC } from "@/_MiniApps/auth/AuthContext";
import { useCMS } from "@hooks/useCMS";
import banners from "@data/banners/login-pages/car_report.json";
import { handleHasAccountEvent } from "@/utils/common";
import useApi from "@hooks/useApi";
import DateSection from "@/pages/post/components/carReportSection/DateSection";
import { usePostDetails } from "@/common/Contexts/PostDetailsContext";
var LENGTH_OF_SHIMMER_ROWS = 9;
var CarReportSection = function CarReportSection(_ref) {
  var isTrackingView = _ref.isTrackingView;
  var _useTranslation = useTranslation(["web_post_view"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateToHard = _useHelpers.navigateToHard;
  var isMobile = useIsMobile();
  var isDesktop = !isMobile;
  var lang = useLang();
  var reportLink = isTrackingView ? "/tracking-report/" : "/report/";
  var _usePostDetails = usePostDetails(),
    helpers = _usePostDetails.helpers;
  var _useCMS = useCMS(),
    imageUrl = _useCMS.imageUrl;
  var authScreenDesign = {
    banners: {
      desktop: imageUrl(banners[lang].desktop_images[0]),
      mobile: imageUrl(banners[lang].mobile_images[0])
    },
    title: t("اطلع على تقرير الفحص الكامل الآن!", {
      ns: "web_post_view"
    }),
    description: t("خلك على تفاصيل السيارة وسجل رقم جوالك بكل سهولة وبسرعة!", {
      ns: "web_post_view"
    })
  };
  var _useApi = useApi([helpers.getPostId()], function () {
      return helpers.getPostId() && api__getPostInspection(helpers.getPostId());
    }),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    inspection = _useApi2[2];
  if (error) {
    return null;
  }
  return /*#__PURE__*/React.createElement(AuthPopupHOC, {
    customModalClassName: "modalHideHeader",
    authScreenDesign: authScreenDesign,
    onCancel: function onCancel() {
      trackEvents("element_click", {
        element_name: "inspection_report",
        user_login_status: "false"
      });
    },
    renderFunc: function renderFunc(checkAuth) {
      var _inspection$car_repor, _inspection$external_, _inspection$external_2, _inspection$external_3;
      return /*#__PURE__*/React.createElement("div", {
        className: stl.container,
        id: "car-inspection-container"
      }, isMobile && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: [stl.headingPart, "m-show"].join(" ")
      }, /*#__PURE__*/React.createElement("h2", null, t("فحص السيارة الشامل", {
        ns: "web_post_view"
      })), /*#__PURE__*/React.createElement("p", null, t("نختار سياراتنا المستعملة وفق معايير دقيقة ونعرض فقط الأفضل", {
        ns: "web_post_view"
      })), /*#__PURE__*/React.createElement("div", {
        className: stl.logosPart,
        id: "inspection-icons-mobile"
      }, /*#__PURE__*/React.createElement("img", {
        width: "55px",
        height: "81px",
        src: CDN_LINK + "/assets/images/engsl.svg",
        alt: "image",
        loading: "lazy"
      }), /*#__PURE__*/React.createElement("img", {
        width: "55px",
        height: "81px",
        src: CDN_LINK + "/assets/images/gearsl.svg",
        alt: "image",
        loading: "lazy"
      }), /*#__PURE__*/React.createElement("img", {
        width: "55px",
        height: "81px",
        src: CDN_LINK + "/assets/images/chassl.svg",
        alt: "image",
        loading: "lazy"
      }), /*#__PURE__*/React.createElement("img", {
        width: "55px",
        height: "81px",
        src: CDN_LINK + "/assets/images/airbagsl.svg",
        alt: "image",
        loading: "lazy"
      })))), /*#__PURE__*/React.createElement("div", {
        className: stl.subContainer1
      }, isDesktop && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: [stl.headingPart, "m-hide"].join(" "),
        id: "inspection-heading-desktop"
      }, /*#__PURE__*/React.createElement("h2", {
        id: "inspection-title-desktop"
      }, t("فحص السيارة الشامل", {
        ns: "web_post_view"
      })), /*#__PURE__*/React.createElement("p", null, t("نختار سياراتنا المستعملة وفق معايير دقيقة ونعرض فقط الأفضل", {
        ns: "web_post_view"
      })), /*#__PURE__*/React.createElement("div", {
        className: stl.logosPart,
        id: "inspection-icons-desktop"
      }, /*#__PURE__*/React.createElement("img", {
        width: "84px",
        height: "81px",
        src: CDN_LINK + "/assets/images/engsl.svg",
        alt: "image",
        loading: "lazy"
      }), /*#__PURE__*/React.createElement("img", {
        width: "84px",
        height: "81px",
        src: CDN_LINK + "/assets/images/gearsl.svg",
        alt: "image",
        loading: "lazy"
      }), /*#__PURE__*/React.createElement("img", {
        width: "84px",
        height: "81px",
        src: CDN_LINK + "/assets/images/chassl.svg",
        alt: "image",
        loading: "lazy"
      }), /*#__PURE__*/React.createElement("img", {
        width: "84px",
        height: "81px",
        src: CDN_LINK + "/assets/images/airbagsl.svg",
        alt: "image",
        loading: "lazy"
      })))), /*#__PURE__*/React.createElement("div", {
        className: "bg-white p-1 mt-1",
        id: "inspection-report-box"
      }, /*#__PURE__*/React.createElement("div", {
        className: stl.sub2Head,
        id: "inspection-points-header"
      }, lang === "ar" ? /*#__PURE__*/React.createElement(ARPointsInspectionSVG, null) : /*#__PURE__*/React.createElement(ENPointsInspectionSVG, null)), /*#__PURE__*/React.createElement("div", {
        className: stl.sub2Data,
        id: "inspection-items-list"
      }, ((inspection === null || inspection === void 0 ? void 0 : inspection.car_report) || Array.from({
        length: LENGTH_OF_SHIMMER_ROWS
      })).map(function (item, idx) {
        return /*#__PURE__*/React.createElement(SingleInspectionItem, {
          tabId: "Itab" + idx,
          index: idx,
          onClick: function onClick() {
            checkAuth(function (userData, isPendingActionCall) {
              isPendingActionCall && handleHasAccountEvent({
                hasAccount: userData.has_account,
                status: "Success",
                phone_number: userData === null || userData === void 0 ? void 0 : userData.phone_number,
                lang: lang,
                referral_location: "inspection_report"
              });
              trackEvents("view_inspection", helpers.getG4_data());
              navigateToHard(reportLink + helpers.getPostId() + "/Itab" + idx);
            });
          },
          key: idx,
          icon: item === null || item === void 0 ? void 0 : item.category_image,
          text: item === null || item === void 0 ? void 0 : item.category_name,
          numberOfPoints: item === null || item === void 0 ? void 0 : item.category_countertext
        });
      }), /*#__PURE__*/React.createElement(SingleInspectionItem, {
        key: 10,
        tabId: "Itab".concat((inspection === null || inspection === void 0 ? void 0 : (_inspection$car_repor = inspection.car_report) === null || _inspection$car_repor === void 0 ? void 0 : _inspection$car_repor.length) || 9),
        onClick: function onClick() {
          checkAuth(function (userData, isPendingActionCall) {
            var _inspection$car_repor2;
            isPendingActionCall && handleHasAccountEvent({
              hasAccount: userData.has_account,
              status: "Success",
              phone_number: userData === null || userData === void 0 ? void 0 : userData.phone_number,
              lang: lang,
              referral_location: "inspection_report"
            });
            trackEvents("view_inspection", helpers.getG4_data());
            navigateToHard(reportLink + helpers.getPostId() + "/Itab" + (inspection === null || inspection === void 0 ? void 0 : (_inspection$car_repor2 = inspection.car_report) === null || _inspection$car_repor2 === void 0 ? void 0 : _inspection$car_repor2.length));
          });
        },
        icon: inspection === null || inspection === void 0 ? void 0 : (_inspection$external_ = inspection.external_body) === null || _inspection$external_ === void 0 ? void 0 : _inspection$external_.category_image,
        text: inspection === null || inspection === void 0 ? void 0 : (_inspection$external_2 = inspection.external_body) === null || _inspection$external_2 === void 0 ? void 0 : _inspection$external_2.category_name,
        numberOfPoints: inspection === null || inspection === void 0 ? void 0 : (_inspection$external_3 = inspection.external_body) === null || _inspection$external_3 === void 0 ? void 0 : _inspection$external_3.category_countertext
      })), /*#__PURE__*/React.createElement("div", {
        className: stl.linkToReport,
        id: "view-full-report-container"
      }, /*#__PURE__*/React.createElement("button", {
        className: "blueBtn",
        id: "view-full-report-button",
        onClick: function onClick(e) {
          checkAuth(function (userData, isPendingActionCall) {
            isPendingActionCall && handleHasAccountEvent({
              hasAccount: userData.has_account,
              status: "Success",
              phone_number: userData === null || userData === void 0 ? void 0 : userData.phone_number,
              lang: lang,
              referral_location: "inspection_report"
            });
            isPendingActionCall && trackEvents("element_click", {
              element_name: "inspection_report",
              user_login_status: "true"
            });
            if (inspection !== null && inspection !== void 0 && inspection.car_report[0]) {
              trackEvents("view_inspection", helpers.getG4_data());

              // Navigate to the report
              navigateToHard(reportLink + helpers.getPostId());
            }
          });
        }
      }, t("شاهد تقرير الفحص الكامل", {
        ns: "web_post_view"
      })))), /*#__PURE__*/React.createElement(DateSection, {
        isTrackingView: isTrackingView,
        inspection: inspection
      })));
    }
  });
};
export default CarReportSection;